document.addEventListener("DOMContentLoaded", function () {
// $(".product-form__submit").addClass("disabled");
  var chooseDeliveryDateBtn = document.getElementById("chooseDeliveryDateBtn");
  var postcodeDiv = document.querySelector(".postcode-hh");

  // Add click event listener to the button
  chooseDeliveryDateBtn.addEventListener("click", function () {
    // Toggle the visibility of the postcodeDiv
    if (postcodeDiv.style.display === "none") {
      postcodeDiv.style.display = "block";
      if ($(".postcode-hh").css("display") === "block") {
        // If displayed as block, add the 'disabled' class to the button
        $(".product-form__submit").addClass("disabled");
        $(".kqsiVA9Jf8LJAbxw8Bau").addClass("disabled");
      }
    } else {
      postcodeDiv.style.display = "none";
    }
  });

  // Function to be executed every 4 seconds
  
});
function updateEvery1Seconds() {
  var postcodeDiv = document.querySelector(".postcode-hh");
    $("#chooseDeliveryDateBtn").on("click", function () {
    // Toggle the visibility of the postcodeDiv
    if (postcodeDiv.style.display === "none") {
      postcodeDiv.style.display = "block";
      if ($(".postcode-hh").css("display") === "block") {
        // If displayed as block, add the 'disabled' class to the button
        $(".product-form__submit").addClass("disabled");
        $(".kqsiVA9Jf8LJAbxw8Bau").addClass("disabled");
      }
    } else {
      postcodeDiv.style.display = "none";
    }
  });

  // Initialize Bootstrap Datepicker
  const datepickerOptions = {
    format: "dd/mm/yyyy",
    autoclose: true,
    orientation: "bottom",
    numberOfMonths: 2,
    startDate: new Date(), // Start from tomorrow
    show: true,
    container: '.delivery-post-codes'
  };

  const datepicker = $("#datepicker").datepicker(datepickerOptions);

  $("#postcode").on("input", function () {
    datepicker.datepicker("setDatesDisabled", []);
    $("#checkDeliveryDateBtn").prop("disabled", false);
  });

  // $("#checkDeliveryDateBtn").on("click", function () {
  //   let enteredPostcode = $("#postcode").val();
  //   let strippedString = "";
  //   if (enteredPostcode.length > 2) {
  //     // Strip the first two characters
  //     $(".kqsiVA9Jf8LJAbxw8Bau").removeClass("disabled");
  //     $(".product-form__submit").removeClass("disabled");
  //     strippedString = enteredPostcode.substring(0, 2);
  //   } else {
  //     $(".kqsiVA9Jf8LJAbxw8Bau").removeClass("disabled");
  //     $(".product-form__submit").removeClass("disabled");
  //     strippedString = enteredPostcode;
  //   }
  //   const currentDeliveryDate = checkDeliveryDate(
  //     strippedString,
  //     new Date().getHours(),
  //     new Date().toLocaleDateString("en-US", { weekday: "long" }),
  //     new Date().toLocaleDateString("en-GB"), // Change date format to DD/MM/YYYY
  //     rulesJson
  //   );

  //   // Display delivery message
  //   if (currentDeliveryDate instanceof Date) {
  //     datepicker.datepicker("setStartDate", currentDeliveryDate);
  //     datepicker.datepicker("setDatesDisabled", []);
  //   } 

  // });

  // Handle date selection
  $("#datepicker").on("changeDate", function (e) {
    const selectedDate = e.date;
    const enteredPostcode = $("#postcode").val();
    const deliveryDate = checkDeliveryDate(
      enteredPostcode,
      selectedDate.getHours(),
      selectedDate.toLocaleDateString("en-US", { weekday: "long" }),
      selectedDate.toLocaleDateString("en-GB"), // Change date format to DD/MM/YYYY
      rulesJson
    );

  });
   if (datepicker) {
    // Add an event listener for the 'input' event on the datepicker
    datepicker.on("input", function () {
      // Check if the datepicker has a value
      if (datepicker.val()) {
        // Remove the 'disable' class from the submit button
        $(".product-form__submit").removeClass("disable");
        // Remove the 'disable' class from the payment button
        $(".kqsiVA9Jf8LJAbxw8Bau").removeClass("disable");
      } else {
        // Add the 'disable' class to the submit button if there is no value
        $(".product-form__submit").addClass("disable");
        // Add the 'disable' class to the payment button if there is no value
        $(".kqsiVA9Jf8LJAbxw8Bau").addClass("disable");
      }
    });
  }
}

$(document).on('click', '.card-information__button', function() {
  console.log("Button clicked!");
 setTimeout(function() {
    // Call your function after the delay
    updateEvery1Seconds();
  }, 3000);
});
const rulesJson = [
  {
    postcode: [
      "E1",
      "E2",
      "E3",
      "E4",
      "E5",
      "E6",
      "E7",
      "E8",
      "E9",
      "EC",
      "HA",
      "IG",
      "N1",
      "N2",
      "N3",
      "N4",
      "N5",
      "N6",
      "N7",
      "N8",
      "N9",
      "NW",
      "SE",
      "SW",
      "WC",
      "W1",
      "W2",
      "W3",
      "W4",
      "W5",
      "W6",
      "W7",
      "W8",
      "W9",
    ],
    pincode_type: "LONDON",
    blocked_dates: [],
    rule: [
      {
        valid_days: [
          "Sunday",
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
        ],
        cutoff: "18",
        offset_days: 0,
      },
    ],
  },
  {
    postcode: [
      "AL",
      "B1",
      "B2",
      "B3",
      "B4",
      "B5",
      "B6",
      "B7",
      "B8",
      "B9",
      "BA",
      "BB",
      "BD",
      "BH",
      "BL",
      "BN",
      "BR",
      "BS",
      "CA",
      "CB",
      "CF",
      "CH",
      "CM",
      "CO",
      "CR",
      "CT",
      "CV",
      "CW",
      "DA",
      "DE",
      "DH",
      "DL",
      "DN",
      "DT",
      "DY",
      "EH",
      "EN",
      "EX",
      "FY",
      "G1",
      "G2",
      "G3",
      "G4",
      "G5",
      "G9",
      "G6",
      "G7",
      "G8",
      "GL",
      "GU",
      "HD",
      "HG",
      "HP",
      "HR",
      "HU",
      "HX",
      "IP",
      "KT",
      "L1",
      "L2",
      "L3",
      "L4",
      "L5",
      "L6",
      "L7",
      "L8",
      "L9",
      "LA",
      "LD",
      "LE",
      "LL",
      "LN",
      "LS",
      "LU",
      "M1",
      "M2",
      "M3",
      "M4",
      "M5",
      "M6",
      "M7",
      "M8",
      "M9",
      "ME",
      "MK",
      "NE",
      "NG",
      "NN",
      "NP",
      "NR",
      "OL",
      "OX",
      "PE",
      "PL",
      "PO",
      "PR",
      "RG",
      "RH",
      "RM",
      "S1",
      "S2",
      "S3",
      "S4",
      "S5",
      "S6",
      "S7",
      "S8",
      "S9",
      "SA",
      "SG",
      "SK",
      "SL",
      "SM",
      "SN",
      "SO",
      "SP",
      "SR",
      "SS",
      "ST",
      "SY",
      "TA",
      "TF",
      "TN",
      "TQ",
      "TR",
      "TS",
      "TW",
      "UB",
      "WA",
      "WD",
      "WF",
      "WN",
      "WR",
      "WS",
      "WV",
      "YO",
    ],
    pincode_type: "REST_OF_UK",
    blocked_dates: [
      "25/12/2023",
      "26/12/2023",
      "27/12/2023",
      "01/01/2024",
      "02/01/2024",
      "29/03/2024",
      "30/03/2024",
      "31/03/2024",
      "01/04/2024",
      "02/04/2024",
      "06/05/2024",
      "07/05/2024",
      "27/05/2024",
      "28/05/2024",
      "26/08/2024",
      "27/08/2024",
    ],
    rule: [
      {
        valid_days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        cutoff: "17",
        offset_days: 1,
      },
      {
        valid_days: ["Sunday", "Saturday"],
        cutoff: "17",
        offset_days: 1,
      },
    ],
  },
  {
    postcode: [
      "AB",
      "DD",
      "DG",
      "FK",
      "HS",
      "IV",
      "KA",
      "KW",
      "KY",
      "ML",
      "PA",
      "PH",
      "TD",
      "ZE",
    ],
    pincode_type: "REST_OF_UK",
    blocked_dates: [
      "25/12/2023",
      "26/12/2023",
      "27/12/2023",
      "01/01/2024",
      "02/01/2024",
      "29/03/2024",
      "30/03/2024",
      "31/03/2024",
      "01/04/2024",
      "02/04/2024",
      "06/05/2024",
      "07/05/2024",
      "27/05/2024",
      "28/05/2024",
      "26/08/2024",
      "27/08/2024",
    ],
    rule: [
      {
        valid_days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        cutoff: "17",
        offset_days: 2,
      },
      {
        valid_days: ["Sunday", "Saturday"],
        cutoff: "17",
        offset_days: 2,
      },
    ],
  },
];

function checkDeliveryDate(inputPostcode, ukTime, ukDay, ukDate, rulesJson) {
  let ruleFoundFlag = "N";
  let offsetDays = 0;
  let pincodeType = "";
  let blockedDates = [];
  
  for (const ruleObj of rulesJson) {
    const postCodes = ruleObj.postcode;
    const cutoffTime = ruleObj.rule[0].cutoff;
    const validDays = ruleObj.rule[0].valid_days;
    blockedDates = ruleObj.blocked_dates;
    
    if (postCodes.includes(inputPostcode.toUpperCase())) {
      for (const rule of ruleObj.rule) {
        if (ukTime < cutoffTime) {
          offsetDays = rule.offset_days;
        } else {
          offsetDays = rule.offset_days + 1;
        }

        ruleFoundFlag = "Y";
        break; // Exit inner loop
      }

      if (ruleFoundFlag === "Y") {
        break; // Exit outer loop
      }
    }
  }
  console.log(ruleFoundFlag);
  if (ruleFoundFlag === "Y") {
    const deliveryDate = new Date();
    deliveryDate.setDate(deliveryDate.getDate() + offsetDays);
    $(".delivery-date-picker-hh").show();
    $("#datepicker").datepicker();
    $("#datepicker").data("datepicker").hide = function () {};
    $("#datepicker").datepicker("show");
    $(".datepicker").css("display", "block");

    return {date: deliveryDate, blockedDates_arr: blockedDates};
  } else {
    return {date: "Invalid Postcode. Delivery available only in the UK and London.", blockedDates_arr: blockedDates};
  }
}
$(document).ready(function() {
  // Initialize Bootstrap Datepicker
  const datepickerOptions = {
    format: 'dd/mm/yyyy',
    autoclose: true,
    orientation: "bottom",
    numberOfMonths: 2,
    startDate: new Date(), // Start from tomorrow
    show: true,
    container: '.delivery-post-codes'
  };

  const datepicker = $("#datepicker").datepicker(datepickerOptions);

  $("#postcode").on("input", function () {
    datepicker.datepicker("setDatesDisabled", []);
    $("#checkDeliveryDateBtn").prop("disabled", false);
  });

  $("#checkDeliveryDateBtn").on("click", function () {
    let enteredPostcode = $("#postcode").val();
    let strippedString = "";
    if (enteredPostcode.length > 2) {
      $(".product-form__submit").removeClass("disabled");
      strippedString = enteredPostcode.substring(0, 2);
    } else {
      $(".product-form__submit").removeClass("disabled");
      strippedString = enteredPostcode;
    }
    
    const currentDeliveryDate = checkDeliveryDate(
      strippedString,
      new Date().getHours(),
      new Date().toLocaleDateString("en-US", { weekday: "long" }),
      new Date().toLocaleDateString("en-GB"), // Change date format to DD/MM/YYYY
      rulesJson
    );
    
    // Display delivery message
    if (currentDeliveryDate.date instanceof Date) {
      $(".error-message").html("");
      datepicker.datepicker("setStartDate", currentDeliveryDate.date);
      datepicker.datepicker("setDatesDisabled", currentDeliveryDate.blockedDates_arr);
    }else{
      $(".error-message").html(currentDeliveryDate.date);
    }
  });


  // Handle date selection
  $("#datepicker").on("changeDate", function (e) {
    const selectedDate = e.date;
    const enteredPostcode = $("#postcode").val();
    const deliveryDate = checkDeliveryDate(
      enteredPostcode,
      selectedDate.getHours(),
      selectedDate.toLocaleDateString("en-US", { weekday: "long" }),
      selectedDate.toLocaleDateString("en-GB"), // Change date format to DD/MM/YYYY
      rulesJson
    );

    // Display delivery message
  });
 if (datepicker) {
    // Add an event listener for the 'input' event on the datepicker
    datepicker.on("input", function () {
      // Check if the datepicker has a value
      if (datepicker.val()) {
        // Remove the 'disable' class from the submit button
        $(".product-form__submit").removeClass("disable");
        // Remove the 'disable' class from the payment button
        $(".kqsiVA9Jf8LJAbxw8Bau").removeClass("disable");
      } else {
        // Add the 'disable' class to the submit button if there is no value
        $(".product-form__submit").addClass("disable");
        // Add the 'disable' class to the payment button if there is no value
        $(".kqsiVA9Jf8LJAbxw8Bau").addClass("disable");
      }
    });
  }
}) 